import { extendTheme } from '@chakra-ui/react';
import { Button } from './Button';
import { Radio } from './Radio';

const theme = extendTheme({
  components: {
    Button,
    Text,
    Radio,
  },
  colors: {
    transparent: 'transparent',
    white: '#FFFFFF',
    green: {
      50: '#E6FBF3',
      100: '#B0F3DA',
      200: '#8AEDC9',
      300: '#54E5B0',
      600: '#01AD6E',
      700: '#009961',
      800: '#00774B',
    },
    blue: {
      100: '#BEE3F8',
      700: '#022D58',
    },
    gray: {
      0: '#FFFFFF',
      50: '#F7FAFC',
      100: '#EDF2F7',
      200: '#C3CBCC',
      300: '#D0D5DD',
      500: '#667085',
      600: '#979797',
      700: '#344054',
      900: '#101828',
    },
    red: {
      50: '#FFEDED',
      100: '#FEC6C6',
      300: '#FDA29B',
      500: '#FD4848',
      600: '#D94040',
      700: '#B43333',
    },
    error: {
      50: '#FEF3F2',
      100: '#FEE4E2',
      600: '#D92D20',
    },
  },
  fonts: {
    heading: `'Lato', sans-serif`,
    body: `'Lato', sans-serif`,
  },
  styles: {
    global: {
      '.amplify-button--primary': {
        backgroundColor: '#01AD6E',
        color: '#FFFFFF',
        fontWeight: '500',
        borderRadius: '0.375rem',
        fontSize: '1rem',
      },
      '.amplify-button--link': {
        color: '#344054',
        _hover: { backgroundColor: '#87eec87b', color: '#344054' },
      },
      '.amplify-alert__dismiss': {
        _hover: { backgroundColor: 'unset' },
      },
      '::-webkit-scrollbar': {
        width: '8px',
      },
      '::-webkit-scrollbar-track': {
        backgroundColor: 'transparent',
      },
      '::-webkit-scrollbar-thumb': {
        backgroundColor: '#d6dee1',
        borderRadius: '20px',
        border: '6px solid transparent',
      },
      'input:-webkit-autofill': {
        WebkitBackgroundClip: 'text',
      },
      'input:-webkit-autofill:hover': {
        WebkitBackgroundClip: 'text',
      },
      'input:-webkit-autofill:focus': {
        WebkitBackgroundClip: 'text',
      },
      'input:-webkit-autofill:active': {
        WebkitBackgroundClip: 'text',
      },
    },
  },
});

export default theme;
